module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "headerSection"
  }, [_c('div', {
    staticClass: "row headerSection--sticky",
    attrs: {
      "id": "sticky-header"
    }
  }, [_c('div', {
    staticClass: "headerSection--header container"
  }, [_c('div', {
    staticClass: "headerSection--header__logo"
  }, [_c('a', {
    staticClass: "a-Link--Blue",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.seratoLogo,
      "alt": "Serato"
    }
  })])])]), _vm._v(" "), (_vm.showOrderTotal) ? _c('MobileNavTotalOrder') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "headerSection--checkout",
    attrs: {
      "id": "header-checkout"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "headerSection--checkout__caption"
  }, [_c('h1', [_vm._v(_vm._s(_vm.headerCaption))])]), _vm._v(" "), _c('div', {
    staticClass: "headerSection--checkout__navBackButton"
  }, [(this.$route.path === '/payment') ? _c('router-link', {
    staticClass: "a-Link--Blue",
    attrs: {
      "to": "/cart"
    }
  }, [_c('i', {
    staticClass: "far fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" back\n          ")]) : (!_vm.inAppPurchase) ? _c('a', {
    staticClass: "a-Link--Blue",
    attrs: {
      "href": _vm.referrerUrl
    }
  }, [_c('i', {
    staticClass: "far fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" back\n          ")]) : _c('div', [_c('br')])], 1)])])]), _vm._v(" "), _c('Message', {
    ref: "messageContainer"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1)]), _vm._v(" "), _c('modal-dialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "modalLoading",
    attrs: {
      "showHeader": false,
      "showFooter": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "a-spinner"
  }, [_c('div', {
    staticClass: "rect1"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect2"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect3"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect4"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect5"
  })]), _vm._v("\n      Please wait ...\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e9ef138","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/App.vue
// module id = 531
// module chunks = 2